var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8434_13469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97826 2.45652H15.5V13.5435H8.97826M8.97826 0.5L0.5 2.13043V13.8696L8.97826 15.5V0.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10742 5.71824L5.71612 10.9356M3.10742 10.9356L5.71612 5.71824M8.97699 3.76172H10.9335V4.41389H8.97699V3.76172ZM12.2379 3.76172H14.1944V4.41389H12.2379V3.76172ZM8.97699 5.71824H10.9335V6.37041H8.97699V5.71824ZM12.2379 5.71824H14.1944V6.37041H12.2379V5.71824ZM8.97699 7.67476H10.9335V8.32694H8.97699V7.67476ZM12.2379 7.67476H14.1944V8.32694H12.2379V7.67476ZM8.97699 9.63128H10.9335V10.2835H8.97699V9.63128ZM12.2379 9.63128H14.1944V10.2835H12.2379V9.63128ZM8.97699 11.5878H10.9335V12.24H8.97699V11.5878ZM12.2379 11.5878H14.1944V12.24H12.2379V11.5878Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8434_13469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.18ecf2611a2f5093d1d1ecac86f65405.svg";
export { ForwardRef as ReactComponent };